const commonStyle={
   fill:'rgba(230,230,230,0.2)', // transparent
   stroke:'#dcdcdc',
   strokeWidth: 0.2,
   outline: "none"
}
const mapStyle = {
   // ----------------------------------------
   circoscrizioni:{
      normal:{
         default:{...commonStyle},
         hover:{...commonStyle, fill:'rgba(230,230,230,0.7)' },
         pressed:{...commonStyle}
      },
      active:{
         default:{...commonStyle,fill:'rgba(230,230,230,0.5)'},
         hover:{...commonStyle,fill:'rgba(230,230,230,0.7)'},
         pressed:{...commonStyle}
      }
   },
   // ----------------------------------------
   regioni:{
      normal:{
         default:{...commonStyle},
         hover:{...commonStyle,  fill:'rgba(230,230,230,0.7)'},
         pressed:{...commonStyle}
      },
      active:{
         default:{...commonStyle, strokeWidth: '0.2', fill:'rgba(230,230,230,0.5)'},
         hover:{...commonStyle,  fill:'rgba(230,230,230,0.7)'},
         pressed:{...commonStyle}
      }
   }
}

export default mapStyle;



// WEBPACK FOOTER //
// ./src/utils/colorsConfig.js